import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiServiceService } from '../../services/common/api-service.service';
import { forkJoin } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-signup-religion',
  templateUrl: './signup-religion.component.html',
  styleUrls: ['./signup-religion.component.scss'],
})
export class SignupReligionComponent implements OnInit {
  @HostListener('document:click', ['$event'])
  clickOutside(event: MouseEvent) {

    const target = event.target as HTMLElement;

    if (!target.closest('.custom-dropdown')) {

      this.showReligionList = false;
      this.showCasteList = false;
      this.showSubCasteList = false;
      this.showGothramList = false;

    }

  }
  castes: any[] = [];
  subcastes: any[] = [];
  gothrams: any[] = [];
  religions: any[] = [];
  natchras: any[] = [];
  rasis: any[] = [];
  signupreligion!: FormGroup;
  errorMessage = '';
  selectedReligionName = '';
  selectedCasteName = '';
  selectedSubCasteName = '';
  selectedGothramName = '';

  filteredReligions: any[] = [];
  filteredCastes: any[] = [];
  filteredSubcastes: any[] = [];
  filteredGothrams: any[] = [];

  showReligionList = false;
  showCasteList = false;
  showSubCasteList = false;
  showGothramList = false;
  constructor(
    private apiService: ApiServiceService,
    private formBuilder: FormBuilder,
    private router: Router,
  ) {
    this.signupreligion = this.formBuilder.group({
      religion: ['', Validators.required],
      caste: ['', Validators.required],
      subcaste: ['', Validators.required],
      gothram: [''],
      dosham: [''],
      star: [''],
      raasi: ['']
    });
  }

  ngOnInit(): void {
    const profileId = localStorage.getItem('profileId');
    const sessionToken = localStorage.getItem('sessionToken');
    if (!profileId || !sessionToken) {
      this.router.navigate(['/signup-basic']);
      return;
    }

    forkJoin([
      this.apiService.getCastes(),
      this.apiService.getSubCastes(),
      this.apiService.getGothrams(),
      this.apiService.getReligions(),
      this.apiService.getNatchra(),
      this.apiService.getRasi()
    ]).subscribe({
      next: ([castesResponse, subcastesResponse, gothramsResponse, religionsResponse, natchraResponse, rasiResponse]) => {
        this.castes = castesResponse.data;
        console.log("ALL CASTES:", this.castes);
        this.subcastes = subcastesResponse.data;
        console.log("ALL SUBCASTES:", this.subcastes);
        this.gothrams = gothramsResponse.data;
        this.religions = religionsResponse.data;
        this.natchras = natchraResponse.data;
        this.rasis = rasiResponse.data;
      },
      error: (error) => {
        console.error('Error fetching religion drop down values:', error);
      },
    });
  }
  openDropdown(type: string) {
    this.showReligionList = false;
    this.showCasteList = false;
    this.showSubCasteList = false;
    this.showGothramList = false;
    if (type === 'religion') {
      this.filteredReligions = this.religions;
      this.showReligionList = true;
    }

    if (type === 'caste') {

      this.showCasteList = true;

    }

    if (type === 'subcaste') {
      this.showSubCasteList = true;
    }

    if (type === 'gothram') {
      this.filteredGothrams = this.gothrams;
      this.showGothramList = true;
    }
  }

  searchDropdown(event: any, type: string) {
    const value = event.target.value.toLowerCase();

    if (type === 'religion') {
      this.filteredReligions = this.religions.filter((x: any) =>
        x.religion_nme.toLowerCase().includes(value),
      );
    }

    if (type === 'caste') {
      this.filteredCastes = this.castes.filter((x: any) =>
        x.caste_nme.toLowerCase().includes(value),
      );
    }

    if (type === 'subcaste') {
      this.filteredSubcastes = this.subcastes.filter((x: any) =>
        x.subcaste_nme.toLowerCase().includes(value),
      );
    }

    if (type === 'gothram') {
      this.filteredGothrams = this.gothrams.filter((x: any) =>
        x.gothram_nme.toLowerCase().includes(value),
      );
    }
  }

  selectDropdown(item: any, type: string) {
    if (type === 'religion') {

      this.selectedReligionName = item.religion_nme;

      this.signupreligion.patchValue({
        religion: item._id,
      });


      // ADD FILTER HERE
      this.filteredCastes = this.castes.filter(
        (caste: any) => caste.religion_id === item._id
      );


      console.log("Selected Religion:", item.religion_nme);
      console.log("Selected Religion ID:", item._id);
      console.log("Filtered Castes:", this.filteredCastes);


      this.showReligionList = false;
      this.updateAstrologyValidators();

      if (this.isNonReligious()) {
        this.selectedCasteName = '';
        this.selectedSubCasteName = '';
        this.selectedGothramName = '';
        this.signupreligion.patchValue({
          caste: '',
          subcaste: '',
          gothram: '',
          dosham: 'Not Applicable',
          star: '',
          raasi: ''
        });
      }
    }

    if (type === 'caste') {

      this.selectedCasteName = item.caste_nme;

      this.signupreligion.patchValue({
        caste: item._id,
      });


      // FILTER SUBCASTES
      this.filteredSubcastes = this.subcastes.filter(
        (sub: any) => sub.caste_id === item._id
      );


      console.log("Selected Caste:", item.caste_nme);
      console.log("Selected Caste ID:", item._id);
      console.log("Filtered Subcastes:", this.filteredSubcastes);


      this.showCasteList = false;
    }

    if (type === 'subcaste') {
      this.selectedSubCasteName = item.subcaste_nme;
      this.signupreligion.patchValue({
        subcaste: item._id,
      });
      this.showSubCasteList = false;
    }

    if (type === 'gothram') {
      this.selectedGothramName = item.gothram_nme;
      this.signupreligion.patchValue({
        gothram: item._id,
      });
      this.showGothramList = false;
    }
  }

  isNonReligious(): boolean {
    const name = (this.selectedReligionName || '').toLowerCase();
    const id = String(this.signupreligion.get('religion')?.value || '');
    return name.includes('non-relig') || name.includes('atheist') || name.includes('secular') || id === '66040275ccff8db6ddf8eecb';
  }

  updateAstrologyValidators() {
    const isNR = this.isNonReligious();
    const isHindu = !isNR && (this.selectedReligionName || '').toLowerCase() === 'hindu';
    const casteCtrl = this.signupreligion.get('caste');
    const subcasteCtrl = this.signupreligion.get('subcaste');
    const gothramCtrl = this.signupreligion.get('gothram');
    const doshamCtrl = this.signupreligion.get('dosham');
    const starCtrl = this.signupreligion.get('star');
    const raasiCtrl = this.signupreligion.get('raasi');

    if (isNR) {
      casteCtrl?.clearValidators();
      subcasteCtrl?.clearValidators();
      gothramCtrl?.clearValidators();
      doshamCtrl?.clearValidators();
      starCtrl?.clearValidators();
      raasiCtrl?.clearValidators();
    } else {
      casteCtrl?.setValidators([Validators.required]);
      subcasteCtrl?.setValidators([Validators.required]);
      if (isHindu) {
        gothramCtrl?.setValidators([Validators.required]);
        doshamCtrl?.setValidators([Validators.required]);
        starCtrl?.setValidators([Validators.required]);
        raasiCtrl?.setValidators([Validators.required]);
      } else {
        gothramCtrl?.clearValidators();
        doshamCtrl?.clearValidators();
        starCtrl?.clearValidators();
        raasiCtrl?.clearValidators();
      }
    }

    casteCtrl?.updateValueAndValidity();
    subcasteCtrl?.updateValueAndValidity();
    gothramCtrl?.updateValueAndValidity();
    doshamCtrl?.updateValueAndValidity();
    starCtrl?.updateValueAndValidity();
    raasiCtrl?.updateValueAndValidity();
  }

  onSubmit() {
    if (this.signupreligion.valid) {
      const formData = this.signupreligion.value;
      const profileId = localStorage.getItem('profileId');
      const sessionToken = localStorage.getItem('sessionToken');

      if (!profileId || !sessionToken) {
        Swal.fire(
          'Error',
          'Session has expired. Please sign up again.',
          'error',
        );
        this.router.navigate(['/signup-basic']);
        return;
      }

      const isNR = this.isNonReligious();
      const requestData = {
        action: 'religious',
        type: 'signup',
        profileId: profileId,
        data: {
          religion_info: {
            religion_id: formData.religion,
            caste_id: isNR ? null : formData.caste,
            sub_caste_id: isNR ? null : formData.subcaste,
            gothrm_id: isNR ? null : (formData.gothram || null),
            dosham: isNR ? 'Not Applicable' : (formData.dosham || null),
            natchr_id: isNR ? null : (formData.star || null),
            rasi_id: isNR ? null : (formData.raasi || null)
          }
        }
      };

      this.apiService.submitReligionData(requestData, sessionToken).subscribe({
        next: (response) => {
          if (response.status === 'success') {
            this.router.navigate(['/signup-personal']);
          } else {
            Swal.fire({
              title: 'Error',
              text: response.message || 'Failed to submit religion details.',
              icon: 'error',
              confirmButtonColor: '#a73453',
            });
          }
        },
        error: (error) => {
          console.error('Submit religion details error:', error);
          Swal.fire({
            title: 'Error',
            text: 'An error occurred. Please try again.',
            icon: 'error',
            confirmButtonColor: '#a73453',
          });
        },
      });
    } else {
      this.signupreligion.markAllAsTouched();
      Swal.fire({
        title: 'Form Invalid',
        text: 'Please select all required religion details.',
        icon: 'warning',
        confirmButtonColor: '#a73453',
      });
    }
  }
}
